import { createUseStyles } from 'react-jss'

const useListSortStyles = createUseStyles(() => ({
  helperClass: {
    backgroundColor: '#fff399 !important',
    zIndex: 99999,
    cursor: 'grab !important'
  }
}))

export { useListSortStyles }
